"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.Divider = exports.Details = exports.Container = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const Logo_1 = require("../Logo");
const react_i18next_1 = require("react-i18next");
exports.Container = styled_components_1.styled.div `
  width: 100%;
  display: flex;
  align-items: stretch;
  background: ${({ theme }) => theme.headerBg};
  box-shadow: ${({ theme }) => theme.boxShadows.standard};
  flex-shrink: 0;
  z-index: 8;
  @media (max-width: ${({ theme }) => theme.screen.small}) {
    flex-direction: column;
    padding-top: ${({ theme }) => theme.gutterHeader};
  }
`;
exports.Details = styled_components_1.styled.div `
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: ${({ theme }) => `${theme.gutterHeader} ${theme.gutterHeader} 5px 20px`};
`;
const CentralText = styled_components_1.styled.span `
  margin-left: 20px;
  height: 30px;
  line-height: 30px;
  display: inline-flex;
  align-items: center;
  padding-bottom: 14px;
  font-size: 24px;
  opacity: 0.6;
`;
exports.Divider = styled_components_1.styled.div `
  width: 1px;
  background: linear-gradient(#fff0, #fff5, #fff0);
  margin: 0 ${({ theme }) => theme.gutterHeader} 0 5px;
`;
const Header = ({ children, logoType, logoClicked, }) => {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    return (react_1.default.createElement(exports.Container, null,
        react_1.default.createElement(exports.Details, null,
            react_1.default.createElement(Logo_1.Logo, { type: logoType, onClick: logoClicked }),
            react_1.default.createElement(CentralText, null, t("heading-Central"))),
        react_1.default.createElement(exports.Divider, null),
        children));
};
exports.Header = Header;
//# sourceMappingURL=Header.js.map